import clsx from 'clsx'
import Cta from '.'
import type { NavigationItemFragment } from '@/lib/types/datocms/graphql/generated'
import Arrow from '@/components/svg/icon/Arrow'

type Props = {
	cta: NavigationItemFragment
	variant?: 'primary' | 'secondary' | 'tertiary'
	download?: boolean
	className?: string
}

export default function CtaTransparent({
	cta,
	variant = 'primary',
	download,
	className,
	...props
}: Props & React.HTMLProps<HTMLButtonElement>) {
	return (
		<Cta
			cta={cta}
			className={clsx(
				'cta group',
				{
					primary:
						'text-white bg-transparent [&_.arrow-container]:text-blue [&_.arrow-container]:bg-white hover:text-white-frosted',
					secondary:
						'text-white bg-transparent [&_.arrow-container]:text-white [&_.arrow-container]:bg-blue hover:text-white-frosted',
					tertiary:
						'text-blue-dark bg-transparent [&_.arrow-container]:text-white [&_.arrow-container]:bg-blue hover:text-contrast',
				}[variant],
				className
			)}
			{...props}
		>
			<span className="button-label tracking-wider">{cta.label ?? 'Learn more'}</span>
			<span className={clsx('arrow-container', { 'rotate-90': download === true })}>
				<Arrow
					className="absolute m-auto group-hover:animate-arrow"
					style={
						{
							'--from': '0, 0',
							'--to': '150%, 0',
						} as React.CSSProperties
					}
				/>
				<Arrow
					className="absolute m-auto group-hover:animate-arrow"
					style={
						{
							'--from': '-150%, 0',
							'--to': '0, 0',
						} as React.CSSProperties
					}
				/>
			</span>
		</Cta>
	)
}
